import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/regenerator";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { ArgumentNullError, Deferred } from "../common/Exports";
import bent from "bent";
export var RestRequestType;

(function (RestRequestType) {
  RestRequestType["Get"] = "GET";
  RestRequestType["Post"] = "POST";
  RestRequestType["Delete"] = "DELETE";
  RestRequestType["File"] = "file";
})(RestRequestType || (RestRequestType = {})); // accept rest operations via request method and return abstracted objects from server response


export var RestMessageAdapter = /*#__PURE__*/function () {
  function RestMessageAdapter(configParams) {
    _classCallCheck(this, RestMessageAdapter);

    if (!configParams) {
      throw new ArgumentNullError("configParams");
    }

    this.privHeaders = configParams.headers;
    this.privIgnoreCache = configParams.ignoreCache;
  }

  _createClass(RestMessageAdapter, [{
    key: "options",
    set: function set(configParams) {
      this.privHeaders = configParams.headers;
      this.privIgnoreCache = configParams.ignoreCache;
    }
  }, {
    key: "setHeaders",
    value: function setHeaders(key, value) {
      this.privHeaders[key] = value;
    }
  }, {
    key: "request",
    value: function request(method, uri) {
      var _this = this;

      var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var body = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var binaryBody = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var responseReceivedDeferral = new Deferred();
      var requestCommand = method === RestRequestType.File ? "POST" : method;

      var handleRestResponse = function handleRestResponse(data) {
        var j = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var d = data;
        return {
          data: JSON.stringify(j),
          headers: JSON.stringify(data.headers),
          json: j,
          ok: data.statusCode >= 200 && data.statusCode < 300,
          status: data.statusCode,
          statusText: j.error ? j.error.message : d.statusText ? d.statusText : d.statusMessage
        };
      };

      var blobToArrayBuffer = function blobToArrayBuffer(blob) {
        var reader = new FileReader();
        reader.readAsArrayBuffer(blob);
        return new Promise(function (resolve) {
          reader.onloadend = function () {
            resolve(reader.result);
          };
        });
      };

      var send = function send(postData) {
        var sendRequest = bent(uri, requestCommand, _this.privHeaders, 200, 201, 202, 204, 400, 401, 402, 403, 404);
        var params = _this.queryParams(queryParams) === "" ? "" : "?" + _this.queryParams(queryParams);
        sendRequest(params, postData).then(function (data) {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var j;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!(method === RestRequestType.Delete || data.statusCode === 204)) {
                      _context.next = 4;
                      break;
                    }

                    // No JSON from Delete and reset (204) operations
                    responseReceivedDeferral.resolve(handleRestResponse(data));
                    _context.next = 14;
                    break;

                  case 4:
                    _context.prev = 4;
                    _context.next = 7;
                    return data.json();

                  case 7:
                    j = _context.sent;
                    responseReceivedDeferral.resolve(handleRestResponse(data, j));
                    _context.next = 14;
                    break;

                  case 11:
                    _context.prev = 11;
                    _context.t0 = _context["catch"](4);
                    responseReceivedDeferral.resolve(handleRestResponse(data));

                  case 14:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[4, 11]]);
          }));
        }).catch(function (error) {
          responseReceivedDeferral.reject(error);
        });
      };

      if (this.privIgnoreCache) {
        this.privHeaders["Cache-Control"] = "no-cache";
      }

      if (method === RestRequestType.File && binaryBody) {
        var contentType = "multipart/form-data";
        this.privHeaders["content-type"] = contentType;
        this.privHeaders["Content-Type"] = contentType;

        if (typeof Blob !== "undefined" && binaryBody instanceof Blob) {
          blobToArrayBuffer(binaryBody).then(function (res) {
            send(res);
          }).catch(function (error) {
            responseReceivedDeferral.reject(error);
          });
        } else {
          send(binaryBody);
        }
      } else {
        if (method === RestRequestType.Post && body) {
          this.privHeaders["content-type"] = "application/json";
          this.privHeaders["Content-Type"] = "application/json";
        }

        send(body);
      }

      return responseReceivedDeferral.promise;
    }
  }, {
    key: "withQuery",
    value: function withQuery(url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var queryString = this.queryParams(params);
      return queryString ? url + (url.indexOf("?") === -1 ? "?" : "&") + queryString : url;
    }
  }, {
    key: "queryParams",
    value: function queryParams() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Object.keys(params).map(function (k) {
        return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
      }).join("&");
    }
  }], [{
    key: "extractHeaderValue",
    value: function extractHeaderValue(headerKey, headers) {
      var headerValue = "";

      try {
        var arr = headers.trim().split(/[\r\n]+/);
        var headerMap = {};
        arr.forEach(function (line) {
          var parts = line.split(": ");
          var header = parts.shift().toLowerCase();
          var value = parts.join(": ");
          headerMap[header] = value;
        });
        headerValue = headerMap[headerKey.toLowerCase()];
      } catch (e) {// ignore the error
      }

      return headerValue;
    }
  }]);

  return RestMessageAdapter;
}();